import React, { Component } from 'react';
import RegExpHelper from '../../../../../Common/Helpers/RegExpHelper';
import InputDefecto from '../../../../../Common/Components/InputDefecto';
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';
import CheckDefecto from '../../../../../Common/Components/CheckDefecto';

class CoeficienteLimiteCompraCabal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rangoCoeficienteMin: props.data.rangoCoeficienteMin,
            rangoCoeficienteMax: props.data.rangoCoeficienteMax,
            rangoCoeficienteDefault: props.data.rangoCoeficienteDefault
        };
    }

    onCoeficienLimiteCompraCabalChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);
        /*Antes de actualizar cualquier cosa, valido que se haya presionado el boton*/
        if (regExp.test(value) && value <= 9 && value != "00" || value.replace(/\s/g, "", "") == "") {
            let newState = {
                [dataset.code]: value
            }

            if (dataset.code == "rangoCoeficienteMin") {
                newState = {
                    ...newState,
                    rangoCoeficienteDefault: value
                }
            }

            this.setState(newState);
        }

    }


    onCoeficienLimiteCompraCabalBlur(event) {
        const { value, dataset } = event.target;
        this.props.changeInput(dataset.code, value);
        if (dataset.code == "rangoCoeficienteMin") {
            this.props.changeInput("rangoCoeficienteDefault",value)
            
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            rangoCoeficienteMin: nextProps.data.rangoCoeficienteMin,
            rangoCoeficienteMax: nextProps.data.rangoCoeficienteMax,
            rangoCoeficienteDefault: nextProps.data.rangoCoeficienteDefault
        });
    }


    render() {
        const { onCoeficienLimiteCompraCabalChange, onCoeficienLimiteCompraCabalBlur } = this;
        let { data, form, changeInput, selectCheckBox } = this.props;

        let pattern0to100 = RegExpHelper.Pattern0to100();
        let acentoLetraIminuscula = ExpHelper.ConvertirCaracter("i");

        let errorLimites = false
        let errorLimiteDefault = false

        if(this.state.rangoCoeficienteMin != "" && this.state.rangoCoeficienteMax != "" && this.state.rangoCoeficienteDefault != ""){
            errorLimites =  !(this.state.rangoCoeficienteMin<=this.state.rangoCoeficienteMax)  
            if(!errorLimites){
                errorLimiteDefault = !(this.state.rangoCoeficienteDefault >= this.state.rangoCoeficienteMin && this.state.rangoCoeficienteDefault <= this.state.rangoCoeficienteMax)
            }
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">{"Coeficiente de L" + acentoLetraIminuscula + "mite de Compra en Cuotas por Cuenta"}</label>
                    <div className="container-radio radio-margin">
                        <div className="row">
                            <div className="col-xs-3"><label className="lbl-radio label-secondary">{"Rango Coeficiente"}</label></div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={3}
                                    value={this.state.rangoCoeficienteMin}
                                    data-code="rangoCoeficienteMin"
                                    data-validation="^(?=.*[0-9])\d{0,2}(?:\.\d{0,1})?$"
                                    onChange={onCoeficienLimiteCompraCabalChange.bind(this)}
                                    onBlur={onCoeficienLimiteCompraCabalBlur.bind(this)}
                                />
                            </div>

                            <div className="col-xs-1"><label>a</label></div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={3}
                                    value={this.state.rangoCoeficienteMax}
                                    data-code="rangoCoeficienteMax"
                                    data-validation="^(?=.*[0-9])\d{0,2}(?:\.\d{0,1})?$"
                                    onChange={onCoeficienLimiteCompraCabalChange.bind(this)}
                                    onBlur={onCoeficienLimiteCompraCabalBlur.bind(this)}
                                />
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-xs-3">
                                <label className="lbl-radio label-secondary">{"Rango Coeficiente exacto por defecto"}</label>
                            </div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={3}
                                    value={this.state.rangoCoeficienteDefault}
                                    data-code="rangoCoeficienteDefault"
                                    data-validation="^(?=.*[0-9])\d{0,2}(?:\.\d{0,1})?$"
                                    onChange={onCoeficienLimiteCompraCabalChange.bind(this)}
                                    onBlur={onCoeficienLimiteCompraCabalBlur.bind(this)}
                                />
                            </div>
                        </div>

                        <div className="lbl-radio">

                            <CheckDefecto
                                referencia={"rangoCoeficienteCheck"}
                                check={data.rangoCoeficienteDefaultInterfaz}
                                selectCheckBox={({ target }) => selectCheckBox("rangoCoeficienteDefaultInterfaz", target.checked)}
                            />
                        </div>

                        {(data.ERROR_PRODUCT["seleccionoRangoCoeficiente"] == false && errorLimites) ? <label className="error">{"El límite inferior debe ser menor o igual al límite superior."}</label> : null}
                        {(data.ERROR_PRODUCT["seleccionoRangoCoeficiente"] == false && errorLimiteDefault) ? <label className="error">{"El valor por defecto debe estar entre el límite inferior y superior."}</label> : null}
                        {(data.ERROR_PRODUCT["seleccionoRangoCoeficiente"] == false && !errorLimites && !errorLimiteDefault ) ? <label className="error">{"Debe ingresar Coeficiente de Límite de Compra en Cuotas por Cuenta."}</label> : null}
                    </div>
                </div>
            </div>
        );
    }
};

export default CoeficienteLimiteCompraCabal;